import fromObjectToValues from 'utils/converters/object/fromObjectToValues.util';

// NOTE: result from beSCustomPermissions

// just a helper to reduce noise
const p = (index, snake, camel) => Object.freeze({ index, snake, camel });

const PERM = {
  //
  // NOTE: avoid using these, they are for testing only

  test: Object.freeze({ index: -2, snake: 'test_test:test', camel: 'test' }),
  none: Object.freeze({ index: -1, snake: 'none_none:none', camel: 'none' }),

  //
  // NOTE: the actual BE related permissions start here

  canViewDailyCashupPersonal: p(5, 'can_view_daily_cashup:personal', 'canViewDailyCashupPersonal'),
  canViewDailyCashupAllStaff: p(6, 'can_view_daily_cashup:all_staff', 'canViewDailyCashupAllStaff'),

  canViewKpiReportsPersonal: p(8, 'can_view_kpi_reports:personal', 'canViewKpiReportsPersonal'),
  canViewKpiReportsAllStaff: p(9, 'can_view_kpi_reports:all_staff', 'canViewKpiReportsAllStaff'),

  canEditStaffPermissions: p(10, 'can_edit_staff_permissions:true', 'canEditStaffPermissions'),

  canEditStaffCommissions: p(15, 'can_edit_staff_commissions:true', 'canEditStaffCommissions'),

  canEditKpisPersonal: p(13, 'can_edit_kpis:personal', 'canEditKpisPersonal'),
  canEditKpisAllStaff: p(14, 'can_edit_kpis:all_staff', 'canEditKpisAllStaff'),

  canViewCalendarAllStaff: p(17, 'can_view_calendar:all_staff', 'canViewCalendarAllStaff'),
  canViewCalendarPersonal: p(18, 'can_view_calendar:personal', 'canViewCalendarPersonal'),
  canViewCalendarNoAccess: p(19, 'can_view_calendar:no_access', 'canViewCalendarNoAccess'),

  // Creating Appointments
  canCreateAppointmentAllStaff: p(100, 'can_create_appointment:all_staff', 'canCreateAppointmentAllStaff'),
  canCreateAppointmentPersonal: p(101, 'can_create_appointment:personal', 'canCreateAppointmentPersonal'),
  canCreateAppointmentNoAccess: p(102, 'can_create_appointment:no_access', 'canCreateAppointmentNoAccess'),

  // Moving Appointments
  canMoveAppointmentAllStaff: p(103, 'can_move_appointment:all_staff', 'canMoveAppointmentAllStaff'),
  canMoveAppointmentPersonal: p(104, 'can_move_appointment:personal', 'canMoveAppointmentPersonal'),
  canMoveAppointmentNoAccess: p(105, 'can_move_appointment:no_access', 'canMoveAppointmentNoAccess'),

  // Deleting Appointments
  canDeleteAppointmentAllStaff: p(106, 'can_delete_appointment:all_staff', 'canDeleteAppointmentAllStaff'),
  canDeleteAppointmentPersonal: p(107, 'can_delete_appointment:personal', 'canDeleteAppointmentPersonal'),
  canDeleteAppointmentNoAccess: p(108, 'can_delete_appointment:no_access', 'canDeleteAppointmentNoAccess'),

  // Editing Appointment Price/Duration
  canEditAppointmentPrice: p(109, 'can_edit_appointment_price:true', 'canEditAppointmentPrice'),
  canEditAppointmentDuration: p(111, 'can_edit_appointment_duration:true', 'canEditAppointmentDuration'),
};

for (const perm of fromObjectToValues(PERM)) {
  PERM[perm.index] = perm;
  PERM[perm.camel] = perm;
  PERM[perm.snake] = perm;
}

// OK, we no longer allow adding permissions to this object
Object.freeze(PERM);

export default PERM;
